import {ModifiersModel} from './dropDownModifiers.model';

export class TripLocationModel {
    public triplocationid: number;
    public tripid: number;
    public isfacility: boolean;
    public ismanualcoordinates: boolean;
    public location: string;
    public streetaddress: string;
    public roomaptnumber: string;
    public city: string;
    public state: string;
    public zip: string;
    public latitude: number;
    public longitude: number;
    public phonenumber: string;
    public alternatephonenumber: string;
    public faxnumber: string;
    public modifierid: number;
    public modifier: ModifiersModel;

    constructor() {
        this.modifier = new ModifiersModel;
    }

}

export class LegModel {
    public leg = [];
    constructor () {

    }

}


// WEBPACK FOOTER //
// ./src/app/pages/trip-reservations/triplocation.model.ts